import type { QuestionDefinition } from "@reno-estimator/core";
import { booleanQuestion, builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion, windowsDoorsQuestion } from "./interior-room-shared.js";

/** Bedroom (Phase 13A) - see rules/bedroom.ts for the matching calculator, and primary-bedroom.ts for the primary bedroom's own question set. */
export const bedroomQuestions: QuestionDefinition[] = [
  flooringQuestion("bedroom", 200, "bedroom"),
  paintingQuestion("bedroom", 210),
  trimQuestion("bedroom", 220),
  lightingQuestion("bedroom", 230),
  builtInsQuestion("bedroom", 240, "What about closet or storage built-ins?", "Custom closet/storage built-ins"),
  windowsDoorsQuestion("bedroom", 250, "Any window or door changes?"),
  booleanQuestion("bedroom_ensuite_rough_in", "bedroom", "Add plumbing rough-in for a future ensuite?", 260, "Rough plumbing only - not a full ensuite build-out.")
];
